import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import LImage from '@max/leez-image';
import PriceDisplay from '../price-display';
import './index.scss';
import { FIRE_ICON, POSITION_ICON, SELECTED_ICON, UN_SELECTED_ICON } from '../../const';
import { replaceWH } from '../../utils/image';
function getTrafficInfoText(info) {
    const typeText = info?.trafficType === 0 ? '步行' : '骑行';
    return `距离选定酒店${info?.distanceText}，${typeText}约${info?.duration}分钟`;
}
const HotelCard = (props) => {
    const { poiId, poiName, frontImg, tags, recommendReason, location, distance, originalPrice, currentPrice, priceLabel, isRecommended, isSelected, hasDiscount, discountText, features, trafficInfo, onSelect, handleNavigate } = props;
    // const { monitorNavigateTo } = useMonitorNavigation();
    // const ctx = useMonitorEngineContext();
    const handleSelect = () => {
        onSelect?.(poiId);
    };
    return <View className="hotel-card" onClick={handleSelect}>
      <View className="hotel-card__image-container">
        <Image className="hotel-card__image" source={{
            uri: replaceWH(frontImg)
        }}/>
        <View x-if={isRecommended} className="hotel-card__recommended-badge">
          <LImage source={{
            uri: isSelected ? SELECTED_ICON : UN_SELECTED_ICON
        }} style={{
            width: '32rpx'
        }}></LImage>
        </View>
      </View>

      <View className="hotel-card__content">
        <View className="hotel-card__info-container">
          <Text className="hotel-card__name" numberOfLines={2}>
            {poiName}
          </Text>

          {recommendReason && <Text className="hotel-card__comment">{recommendReason}</Text>}

          <View className="hotel-card__location-row">
            <LImage source={{
            uri: POSITION_ICON
        }} className={'position-icon'} style={{
            width: '24rpx'
        }}></LImage>
            <Text className="hotel-card__location" numberOfLines={1}>
              {isRecommended && trafficInfo ? getTrafficInfoText(trafficInfo) : location}
            </Text>
          </View>

          {/* {features && features.length > 0 && <Text className="hotel-card__features">{features.join(' ')}</Text>} */}
          <View x-if={isRecommended} className="hotel-card__tags">
            {tags.slice(0, 3).map((tag, index) => <>
                <Text key={index} className="hotel-card__tag">
                  {tag}
                </Text>
              </>)}
          </View>

          {!isRecommended && discountText && <View className="hotel-card__discount">
              <LImage source={{
                uri: FIRE_ICON
            }} className={'fire-icon'} style={{
                width: '24rpx'
            }}></LImage>
              <Text className="hotel-card__discount-text">{discountText}</Text>
            </View>}

          {/* {!isRecommended && (
          <View className="hotel-card__price-change">
            <Text className="hotel-card__price-change-text">{"近一月价格走势"}</Text>
          </View>
         )} */}
        </View>

        <PriceDisplay currentPrice={currentPrice} originalPrice={originalPrice} priceLabel={priceLabel} isRecommended={isRecommended} handleNavigate={() => {
            handleNavigate?.(poiId);
        }}></PriceDisplay>
      </View>
    </View>;
};
export default memo(HotelCard);
